import * as React from "react";
import { StandardProps } from "@material-ui/core";
import MuiTableRow, {
    TableRowBaseProps as MuiTableRowBaseProps,
    TableRowClassKey as MuiTableRowClassKey
} from "@material-ui/core/TableRow";


export type TableRowBaseProps = MuiTableRowBaseProps;
export type TableRowClassKey = MuiTableRowClassKey;

export interface TableRowProps extends StandardProps<TableRowBaseProps, TableRowClassKey> {
    component?: React.ReactType<TableRowBaseProps>;
    hover?: boolean;
    selected?: boolean;
}

class TableRow extends React.Component<TableRowProps>{

    render() {
        const { ...props } = this.props;

        return <MuiTableRow {...props}>
            {this.props.children}
        </MuiTableRow>
    }

}

export default TableRow;

